    // Static package data
    const availablePackages = [
        {
            name_si: "Family",
            name_en: "Family",
            unit_price: 120,
            unites_per_package: 10,
            price: 1200,
            validity: 366,
            data_renention: 730,
            description_si: "ඔබේ පවුලේ සියලුම සාමාජිකයින්ටම වසර 2ක් ඇතුළත භාවිත කළ හැකි Family පැකේජය, රු. 1,200කට.",
            description_en: "For your whole family—10 members, 2 years, just Rs. 1,200.",
            is_active: true,
            package_id: "100-family"
        },
        {
            name_si: "Basic",
            name_en: "Basic",
            unit_price: 40,
            unites_per_package: 50,
            price: 2000,
            validity: 183,
            data_renention: 730,
            description_si: "Lite පැකේජය, 6 මාසයක් ඇතුළත ඒකක 100ක්, රු. 2000කට.",
            description_en: "Lite Package—100 units, 6 months, Rs. 2,000.",
            is_active: true,
            package_id: "200-basic"
        },
        {
            name_si: "Lite",
            name_en: "Lite",
            unit_price: 36,
            unites_per_package: 100,
            price: 3600,
            validity: 366,
            data_renention: 730,
            description_si: "Lite පැකේජය, වසර 1ක් ඇතුළත ඒකක 100ක්, රු. 3,600.",
            description_en: "Lite Package—100 units, 1 year, Rs. 3,600.",
            is_active: true,
            package_id: "300-lite"
        },
        {
            name_si: "Pro",
            name_en: "Pro",
            unit_price: 30,
            unites_per_package: 300,
            price: 9000,
            validity: 365,
            data_renention: 730,
            description_si: "Pro පැකේජය, වසර 1ක් ඇතුළත ඒකක 300ක්, රු. 9,000.",
            description_en: "Pro Package—300 units, 1 year, Rs. 9,000.",
            is_active: true,
            package_id: "400-pro"
        }
    ];
// Helper to decode JWT
function decodeJwt(token) {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    } catch (e) {
        return null;
    }
}

// Get Google token from localStorage and decode
let googleUser = null;
const googleToken = window.localStorage.getItem('googleToken');
if (googleToken) {
    googleUser = decodeJwt(googleToken);
}
import React, { useEffect, useState } from "react";
import SubscriptionService from "app/services/SubscriptionServices";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import TopNavBar from "app/layout/TopNavBar";

function AccountSubscriptionsTable({ }) {

    const tableStyles = {
        table: {
            width: "100%",
            minWidth: 700,
            borderCollapse: "collapse",
            margin: "24px 0",
            fontSize: "1em",
            background: "#fff",
            borderRadius: "16px",
            overflow: "hidden"
        },
        th: {
            border: "1px solid #ddd",
            padding: "8px",
            background: "#eee",
            fontWeight: "bold",
            textAlign: "left"
        },
        td: {
            border: "1px solid #ddd",
            padding: "8px"
        },
        trAlt: {
            background: "#fafafa"
        }
    };


    const [subscriptions, setSubscriptions] = useState([]);
    const subscriptionService = SubscriptionService();
    const fetchData = async () => {
        try {
            const subs = await subscriptionService.getSubscriptions();
            setSubscriptions(subs);
        } catch (err) {
            setSubscriptions([]);
        }
    };
    useEffect(() => {

        fetchData();
    }, []);

    return (
        <DashboardLayout>
            <TopNavBar />
            <style>
                {`
                .account-sub-table th, .account-sub-table td {
                border: 1px solid #ddd;
                padding: 8px;
                }
                .account-sub-table th {
                background: #eee;
                font-weight: bold;
                text-align: left;
                }
                .account-sub-table tr:nth-child(even) {
                background: #fafafa;
                }
                .account-sub-profile {
                display: flex;
                align-items: center;
                margin-bottom: 24px;
                }
                .account-sub-profile-img {
                width: 64px;
                height: 64px;
                border-radius: 50%;
                margin-right: 16px;
                border: 2px solid #eee;
                }
                .account-sub-contact-list {
                list-style: none;
                padding: 0;
                text-align: center;
                max-width: 600px;
                margin: 0 auto;
                }
                .account-sub-contact-list li {
                margin-bottom: 12px;
                }
                .account-sub-buy-section {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                margin-top: 32px;
                }
            `}
            </style>
            {googleUser && (
                <div className="account-sub-profile">
                    <img src={googleUser.picture} alt="Profile" className="account-sub-profile-img" />
                    <div>
                        <div style={{ fontWeight: "bold", fontSize: "1.1em" }}>{googleUser.name}</div>
                        <div style={{ color: "#555" }}>{googleUser.email}</div>
                    </div>
                </div>
            )}
            <h3>My Subscriptions | මගේ පැකේජ්යන්</h3>
            <div></div>
            <p>Here you can view your active subscriptions and their details.</p>
            <div style={{ width: "100%", overflowX: "auto" }}>
                <table className="account-sub-table" style={tableStyles.table}>
                <thead>
                    <tr>
                        <th style={tableStyles.th}>Package ID | පැකේජ්ය</th>
                        <th style={tableStyles.th}>Points | ලකුණු</th>
                        <th style={tableStyles.th}>Points Balance | ලකුණු ශේෂය</th>
                        <th style={tableStyles.th}>Start Date | ආරම්භක දිනය</th>
                        <th style={tableStyles.th}>End Date | අවසන් දිනය</th>
                    </tr>
                </thead>
                <tbody>
                    {subscriptions.map((sub, idx) => (
                        <tr key={idx} style={idx % 2 ? tableStyles.trAlt : {}}>
                            <td style={tableStyles.td}>{sub.package_name}</td>
                            <td style={tableStyles.td}>{(sub.price / sub.unit_price).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                            <td style={{ ...tableStyles.td, background: sub.balance === 0 ? '#ffdddd' : '#ddffdd', color: sub.balance === 0 ? '#b20000' : undefined }}>
                                {(sub.balance / sub.unit_price).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                            </td>
                            <td style={tableStyles.td}>{sub.start_date ? sub.start_date.substring(0, 10) : "-"}</td>
                            <td style={tableStyles.td}>{sub.end_date ? sub.end_date.substring(0, 10) : "-"}</td>
                        </tr>
                    ))}
                </tbody>
                </table>
            </div>
            <hr />
            <div className="account-sub-buy-section">
                <h3 style={{ textAlign: "center", marginBottom: "8px" }}>Buy New Subscription | මිලදී ගන්න </h3>
                <h3 className="brand-color" style={{ textAlign: "center", marginBottom: "16px" }}>Contact Us</h3>
                <ul className="account-sub-contact-list">
                    <li>
                        <strong>Colombo | කොළඹ : </strong>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-telephone" viewBox="0 0 16 16" style={{ verticalAlign: "middle" }}>
                            <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                        </svg>
                        <a style={{ color: "#333", marginLeft: "8px", marginRight: "8px" }} href="tel:+94765243543">+94 765 243 543 | </a>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-whatsapp" viewBox="0 0 16 16" style={{ verticalAlign: "middle" }}>
                            <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                        </svg>
                        <a style={{ color: "#25D366", marginLeft: "8px" }} href="https://wa.me/94765243543">WhatsApp</a>
                    </li>
                </ul>
                <h4 style={{ color: "#0000ff", marginLeft: "8px" }}>Price: Rs 1,200 සිට*</h4>
            <div style={{ marginTop: 32, width: "100%", maxWidth: 700 }}>
                <h3 style={{ textAlign: "center", color: "#333", marginBottom: 16 }}>Available Packages</h3>
                {availablePackages.map(pkg => (
                    <div key={pkg.package_id} style={{ border: "1px solid #ddd", borderRadius: 12, marginBottom: 18, padding: 16, background: "#f9f9ff" }}>
                        <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 4 }}>{pkg.name_en} <span style={{ color: "#888", fontSize: 15 }}></span></div>
                        <div style={{ color: "#0000bb", fontWeight: 500, marginBottom: 6 }}>Price: Rs {pkg.price.toLocaleString()} | Points: {pkg.unites_per_package} </div>
                        <div style={{ color: "#444", fontSize: 15, marginBottom: 4 }}>{pkg.description_en}</div>
                        <div style={{ color: "#888", fontSize: 14 }}>{pkg.description_si}</div>
                    </div>
                ))}
            </div>
                <br />
                <h5>Fee to start</h5>
                <h5>Pay as you go</h5>
                <h5>24/7 access</h5>
                <h5>Worldwide access</h5>
                <h5>Use on any web browser on desktop, tab device or mobile device(Android/Apple)</h5>
            </div>
        </DashboardLayout>
    );
};

export default AccountSubscriptionsTable;
